import FileUploadIcon from '@mui/icons-material/FileUpload'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { Box, Button, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

const Input = styled('input')({
  opacity: 0,
  height: '100%',
  width: '100%',
})

interface IUploadFile {
  accept?: string
  uploadLabelText: string
  uploadButtonText: string
  isDisabled: boolean
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

/**
 * FileUploadArea
 * ファイルアップロードのUI
 * @param uploadLabelText
 * @param uploadButtonText
 * @param isDisabled
 * @param handleFileChange
 * @constructor
 */
export const FileUploadArea: React.FC<IUploadFile> = ({
  accept = '*',
  uploadLabelText = '',
  uploadButtonText = '',
  isDisabled = false,
  handleFileChange,
}) => {
  return isDisabled ? (
    <Box
      sx={{
        width: '352px',
        background: '#F7F7F7',
        border: '3px dashed #EEEEEE',
        borderRadius: '4px',
        textAlign: 'center',
        padding: '16px',
        position: 'relative',
      }}
    >
      <IconButton aria-label="upload picture" sx={{ width: '70px', height: '70px' }}>
        <UploadFileIcon sx={{ width: '64px', height: '64px' }} htmlColor={'#D4D4D4'} />
      </IconButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant={'body1'}
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.15px',
            color: '#D4D4D4',
          }}
        >
          {uploadLabelText}&nbsp;
        </Typography>
        <Button
          variant="outlined"
          startIcon={<FileUploadIcon />}
          sx={{ color: '#D4D4D4', borderColor: '#D4D4D4', fontSize: '13px', height: '30px' }}
        >
          {uploadButtonText}
        </Button>
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        width: '352px',
        background: '#FFFFFF',
        border: '3px dashed #EEEEEE',
        borderRadius: '4px',
        textAlign: 'center',
        padding: '16px',
        position: 'relative',
      }}
    >
      <IconButton aria-label="upload picture" sx={{ width: '70px', height: '70px' }}>
        <UploadFileIcon sx={{ width: '64px', height: '64px' }} />
      </IconButton>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant={'body1'}
          sx={{
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.15px',
            color: '#000000',
          }}
        >
          {uploadLabelText}&nbsp;
        </Typography>
        <Button
          sx={{ fontSize: '13px', height: '30px' }}
          variant="outlined"
          startIcon={<FileUploadIcon />}
        >
          {uploadButtonText}
        </Button>
        <Input
          sx={{
            position: 'absolute',
            top: 0,
          }}
          accept={accept}
          id="icon-button-file"
          type="file"
          onChange={handleFileChange}
        />
      </Box>
    </Box>
  )
}
